import { render, staticRenderFns } from "./AppHeaderProfile.vue?vue&type=template&id=0f61f23b&scoped=true&"
import script from "./AppHeaderProfile.vue?vue&type=script&lang=js&"
export * from "./AppHeaderProfile.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderProfile.vue?vue&type=style&index=0&id=0f61f23b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f61f23b",
  null
  
)

export default component.exports